<template>
  <div class="sp-template">
    <div class="h-title">单独报价订单</div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <el-form :inline="true" :model="queryForm" class="header-search__form" size="small" label-width="90px">
          <el-row>
            <el-form-item label="客户">
              <el-select v-model="queryForm.customerIds" clearable multiple placeholder="选择客户">
                <el-option v-for="(d, i) in customers" :key="i" :label="d.name" :value="d.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="渠道">
              <el-select v-model="queryForm.productIds" clearable multiple placeholder="选择渠道">
                <el-option v-for="(d, i) in channels" :key="i" :label="d.name" :value="d.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="订单号">
              <el-input v-model.lazy="queryForm.orderId" placeholder="订单号"></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="仓库">
              <el-select v-model.lazy="queryForm.warehouseIds" filterable clearable multiple>
                <el-option v-for="(d, i) in warehouses" :key="i" :label="d.name" :value="d.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="开始日期">
              <el-date-picker v-model.lazy="queryForm.startDate" type="date" value-format="yyyy-MM-dd" placeholder="开始日期"></el-date-picker>
            </el-form-item>
            <el-form-item label="结束日期">
              <el-date-picker v-model.lazy="queryForm.endDate" type="date" value-format="yyyy-MM-dd" placeholder="结束日期"></el-date-picker>
            </el-form-item>
          </el-row>
          <div class="search-form__buttons">
            <el-button v-if="in_configs(42001)" size="small" type="primary" @click="searchTask()">搜索</el-button>
            <el-button v-if="in_configs(42001)" size="small" @click="reset()">清空</el-button>
          </div>
        </el-form>
      </div>
      <div class="table-operate__buttons">
        <el-tabs v-model="queryForm.status" @tab-click="searchTask">
					<el-tab-pane v-if="in_configs(42003)" label="待处理" name="0"></el-tab-pane>
					<el-tab-pane v-if="in_configs(42004)" label="完成" name="1"></el-tab-pane>
					<el-tab-pane v-if="in_configs(42005)" label="异常" name="-1"></el-tab-pane>
				</el-tabs>
      </div>
      <el-table :data="tableData" border stripe style="width: 100%" max-height="800">
        <el-table-column prop="id" label="订单号" width="120"></el-table-column>
        <el-table-column prop="orgOwnerName" label="客户" width="120"></el-table-column>
        <el-table-column label="仓库">
          <template slot-scope="scope">
            {{warehouseMap[scope.row.warehousCode]}}
          </template>
        </el-table-column>
        <el-table-column prop="productName" label="渠道" width="120"></el-table-column>
        <el-table-column prop="contractName" label="联系人"></el-table-column>
        <el-table-column prop="phone" label="联系方式"></el-table-column>
        <el-table-column prop="date" label="下单时间" width="160"></el-table-column>
        <el-table-column prop="totalWeight" label="货物重量(kg)"></el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button v-if="in_configs(42006) && queryForm.status == '0' && editCartonStatus.indexOf(scope.row.status) == '-1'" type="text" @click="quote(scope.row)">报价</el-button>
            <el-button v-if="in_configs(42007) && queryForm.status == '1' && editCartonStatus.indexOf(scope.row.status) == '-1'" type="text" @click="quoteEdit(scope.row)">编辑报价</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </el-card>
    <!-- 添加费用弹出框 -->
    <el-dialog title="订单单独报价" :visible.sync="dialogFormVisible" width="1000px">
      <!-- 重量段及费用--> 
      <el-form ref="priceDefinition" :model="priceDefinition" size="small">
        <el-form-item label="分区:">
          {{priceDefinition.mainCharge.logisticPrice.selectedAreaCode}}
          <el-tooltip class="item" effect="dark" content="添加费用" placement="top-start">
            <a href="#" class="el-icon-circle-plus-outline download-icon__blue"  @click.prevent="addMainCharge" style="margin-left:20px;"></a>
          </el-tooltip>
        </el-form-item>
        <el-table :data="priceDefinition.mainCharge.logisticPrice.prices[priceDefinition.mainCharge.logisticPrice.selectedAreaCode]" border >
          <el-table-column label="重量从" width="100px">
            <template slot-scope="scope">
              <span v-if="!isEditPrice">{{scope.row.from}}</span>
              <el-input size="small" ref:input v-if="isEditPrice" v-model="scope.row.from" />
            </template>
          </el-table-column>
          <el-table-column label="重量到" width="100px">
            <template slot-scope="scope">
              <span v-if="!isEditPrice">{{scope.row.to}}</span>
              <el-input size="small" ref:input v-if="isEditPrice" v-model="scope.row.to" />
            </template>
          </el-table-column>
          <el-table-column label="计费重量单位" width="120px">
            <template slot-scope="scope">
              <span v-if="!isEditPrice">{{scope.row.unitWeight}}</span>
              <el-input size="small" ref:input v-if="isEditPrice" v-model="scope.row.unitWeight" />
            </template>
          </el-table-column>
          <el-table-column label="费用定义分类" width="250px">
            <template slot-scope="scope">
              <span v-if="!isEditPrice && 'COST' === scope.row.chargeType">成本</span>
              <span v-else-if="!isEditPrice && 'CONSTANT' === scope.row.chargeType">固定费用</span>
              <span v-else-if="!isEditPrice && 'UNITPRICE' === scope.row.chargeType">简单单价（重量*单价）</span>
              <span v-else-if="!isEditPrice && 'CHAINED' === scope.row.chargeType">续重单价（除扣前一个重量段剩下的重量 * 单价）</span>
              <el-select size="small" name="currency" v-if="isEditPrice" v-model="scope.row.chargeType" style = "width: 100%;" placeholder = "请选择费用定义分类">
                <el-option v-for="(chargeType, index) in chargeTypes" :value="chargeType.value" :label="chargeType.name" :key="index"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="重量段费用">
            <template slot-scope="scope">
              <span v-if="!isEditPrice">{{scope.row.price}}</span>
              <el-input size="small" type="textarea" :rows="2" ref:input v-if="isEditPrice" v-model="scope.row.price" />
            </template>
          </el-table-column>
          <el-table-column label="成本价">
            <template slot-scope="scope">
              <span v-if="!isEditPrice">{{scope.row.costPrice}}</span>
              <el-input size="small" type="textarea" :rows="2" ref:input v-if="isEditPrice" v-model="scope.row.costPrice" />
            </template>
          </el-table-column>
          <el-table-column label="操作" width="50px">
            <template slot-scope="scope">
                <a class="el-icon-delete" @click.prevent="deletePrice(scope.$index, scope.row)"></a>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top: 20px;"
          v-show="priceDefinition.mainCharge.logisticPrice.prices[priceDefinition.mainCharge.logisticPrice.selectedAreaCode] != null
          && priceDefinition.mainCharge.logisticPrice.prices[priceDefinition.mainCharge.logisticPrice.selectedAreaCode].length > 0">
          <el-button size="small" type="warning" @click="editPrice">全部编辑</el-button>
          <el-button size="small" type="success" @click="savePrice(priceDefinition.mainCharge.logisticPrice.prices[priceDefinition.mainCharge.logisticPrice.selectedAreaCode])" v-if = "isEditPrice">保存</el-button>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogFormVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="submitDone()">确 定</el-button>
      </div>
    </el-dialog>
    <!--添加重量段及费用-弹出层-->
    <el-dialog title="添加重量段及费用" :visible.sync="dialogFromVisible" append-to-body width="600px" class="fullwidth-form__dialog">
      <el-form :model="newPrice" size="small" ref="newPriceForm" :rules="newPriceValidate" :label-width="formLabelWidth">
        <el-form-item label="重量从" prop="from">
          <el-input v-model="newPrice.from" placeholder="如 “0.0”"></el-input>
        </el-form-item>
        <el-form-item label="重量到">
          <el-input v-model="newPrice.to" placeholder="如 “1.0”"></el-input>
        </el-form-item>
        <el-form-item label="计费重量单位" prop="unitWeight">
          <el-input v-model="newPrice.unitWeight" placeholder="如 “2.0”"></el-input>
        </el-form-item>
        <el-form-item label="费用定义分类">
          <el-select name="currency" v-model="newPrice.chargeType" style = "width: 100%;" placeholder = "请选择费用定义分类">
            <el-option v-for="(chargeType, index) in chargeTypes" :value="chargeType.value" :label="chargeType.name" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="重量段费用" prop="price">
          <el-input type="textarea" :rows="2" v-model="newPrice.price" placeholder="可以是一个数值或者是一个计算公式"></el-input>
        </el-form-item>
        <el-form-item label="成本价" prop="costPrice">
          <el-input type="textarea" :rows="2" v-model="newPrice.costPrice" placeholder="如 “19.8”"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogFromVisible = false">取消</el-button>
        <el-button size="small" type="warning" @click="createPriceAndContinue('newPriceForm')">确定并继续添加</el-button>
        <el-button size="small" type="primary" @click="createPrice">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    var validateFrom = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入重量"));
      }
      setTimeout(() => {
        var re = /^[0-9]+.?[0-9]*$/;
        if (!re.test(value)) {
          callback(new Error("请输入数字值"));
        } else {
          if (value < 0) {
            callback(new Error("数值必须大于0"));
          } else {
            callback();
          }
        }
      }, 1);
    };
    var validateUnitWeight = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入计费重单位"));
      }
      setTimeout(() => {
        var re = /^[0-9]+.?[0-9]*$/;
        if (!re.test(value)) {
          callback(new Error("请输入数字值"));
        } else {
          if (value < 0) {
            callback(new Error("数值必须大于0"));
          } else {
            callback();
          }
        }
      }, 1);
    };
    return {
      warehouses: [],
      warehouseMap: {},
      priceDefinition: {
        mainCharge: {
          name: "mainCharge",
          formula: null,
          logisticPrice: {
            areas: [],
            prices: {},
            selectedAreaCode: ""
          }
        }
      },
      dialogDefinitionVisible: false,
      priceLayerIndex: 0,
      basicVariable: [],
      queryForm: {
        warehouseIds: [],
        orderId: "",
        status: "0",
        customerIds: [],
        productIds: [],
        startDate: "",
        endDate: "",
        export: 0
      },
      customers: [],
      customerMaps: {},
      channels: [],
      channelsMaps: {},
      status: "未处理",
      priceForm: {
        orderId: "",
        channelId: "",
        billedWeightCalculationMethod: "",
        priceDefinitions: [],
        editId: "" //编辑用的id
      },
      unitWeight: "",
      minTotalWeight: "",
      tableData: [],
      drivers: [],
      vehicles: [],
      driversMap: {},
      vehiclesMap: {},
      dialogFormVisible: false,
      cartonQty: 0,
      orderId: "",
      //价格弹出框相关属性
      formLabelWidth: "120px",
      dialogFromVisible: false,
      isEditPrice: false,
      newPrice: {
        areaCode: "",
        from: "",
        to: "",
        unitWeight: "",
        price: "",
        costPrice: "",
        chargeType: "CONSTANT",
        expr: ""
      },
      newPriceValidate: {
        from: [{ validator: validateFrom, trigger: "blur", required: true }],
        unitWeight: [
          { validator: validateUnitWeight, trigger: "blur", required: true }
        ],
        price: [
          { trigger: "blur", message: "请输入重量段费用", required: true }
        ],
        costPrice: [
          { trigger: "blur", message: "请输入成本价", required: true }
        ]
      },
      chargeTypes: [
        { name: "固定费用", value: "CONSTANT" },
        { name: "简单单价（重量*单价）", value: "UNITPRICE" },
        {
          name: "续重单价（除扣前一个重量段剩下的重量 * 单价）",
          value: "CHAINED"
        }
      ],
      editCartonStatus: [
        "capacity_allocation",
        "batch_operation",
        "shipping",
        "origin_scan",
        "delivery",
        "send_back",
        "canceled"
      ],
      //分页的数据
      pageSizes: [10, 20, 50, 100],
      pageSize: 10,
      total: 0,
      currentPage: 1 //当前页
    };
  },
  created() {
    setTimeout(() => {
      this.findAllChannle();
      this.findByCustomerName();
      // 仓库加载后加载订单
      this.queryWarehouseList();
      //this.queryDriver();
      //this.queryVehicles();
    }, 1000);
  },
  components: {},
  computed: {
    configs() {
      return JSON.parse(sessionStorage.configs);
    }
  },
  methods: {
    reset() {
      this.queryForm = {
        warehouseIds: [],
        orderId: "",
        status: "0",
        customerIds: [],
        productIds: [],
        startDate: "",
        endDate: "",
        export: 0
      };
      this.searchTask();
    },
    queryWarehouseList() {
      let _this = this;
      _this.$request1
        .get(
          '/warehouse/staff',
          {
            withCredentials: true
          }
        )
        .then(function(res) {
          // console.log(res);
          _this.warehouses = res.data;
          _this.warehouses.forEach(a => {
            _this.warehouseMap[a.id] = a.name;
          });
          _this.queryOrder();
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    //查询渠道
    findAllChannle() {
      let _this = this;
      this.$request1
        .get(
          '/system/channel/all',
          {
            withCredentials: true
          }
        )
        .then(function(res) {
          _this.channels = res.data;
          if (_this.channels.length > 0) {
            _this.channels.forEach(c => {
              _this.channelsMaps[c.id] = c.name;
            });
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    //查询客户
    findByCustomerName() {
      let _this = this;
      this.$request1
        .get(
          '/customerAll',
          {
            withCredentials: true
          }
        )
        .then(function(res) {
          if (res.data.success) {
            _this.customers = res.data.data;
            if (_this.customers.length > 0) {
              _this.customers.forEach(c => {
                _this.customerMaps[c.id] = c.name;
              });
            }
          } else {
            _this.$message.error(res.data.message);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    // 通过渠道ID查重量单位和最小计费重
    getChannelById(channelId) {
      this.$request1({
        type: 'GET',
        url: '/system/channel/getChannel/' + channelId + '',
        xhrFields: {
          withCredentials: true
        }
      })
        .then(response => {
          this.unitWeight = String(response.data.unitWeight);
          this.minTotalWeight = String(response.data.minTotalWeight);
          if (response.data.billedWeightCalculationMethod) {
            this.priceForm.billedWeightCalculationMethod =
              response.data.billedWeightCalculationMethod;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    getPriceDefinition(result) {
      this.dialogDefinitionVisible = false;
      result.updateOrAdd = "yes";
      if (this.priceDefinition.effectiveFrom === undefined) {
        this.priceDefinition = result;
        this.priceDefinition.id = "";
        this.priceForm.priceDefinitions.push(this.priceDefinition);
      } else {
        this.priceForm.priceDefinitions = this.priceForm.priceDefinitions.map(
          item => {
            if (item.id == result.id) {
              return result;
            } else {
              return item;
            }
          }
        );
      }
    },
    close(val) {
      this.dialogDefinitionVisible = val;
    },
    //搜索
    searchTask() {
      this.currentPage = 1;
      this.queryOrder();
      //console.log("搜索");
    },
    //编辑
    handleEdit(index, row) {
      row.assign = false;
      //console.log(index, row);
    },
    //保存司机车辆
    handleSave(index, row) {
      let _this = this;
      if (!row.driver.id || !row.vehicle.id) {
        this.$message.error("车辆或司机不能为空");
        return;
      }
      row.assign = true;
      row.driver.name = this.driversMap[row.driver.id];
      row.vehicle.name = this.vehiclesMap[row.vehicle.id];
      this.$request1
        .post(
          '/driver-task',
          {
            driverId: row.driver.id,
            vehicleId: row.vehicle.id,
            orderId: row.id
          },
          {
            withCredentials: true,
            headers: {
              "content-type": "application/json"
            }
          }
        )
        .then(function(response) {
          if (response.data.success) {
            _this.$message({
              message: "保存成功",
              type: "success"
            });
          }
        });
    },
    //分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.queryOrder();
      //console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      //console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.queryOrder();
    },
    queryOrder() {
      let _this = this;
      //过滤仓库
      let wlist = [];
      if (this.warehouses != null && this.warehouses.length > 0) {
        if (
          _this.queryForm.warehouseIds &&
          _this.queryForm.warehouseIds.length > 0
        ) {
          wlist = _this.queryForm.warehouseIds;
        } else {
          wlist = this.warehouses.map(a => a.id);
        }
      } else {
        wlist.push("NOT MATCHING");
      }
      let formdata = {
        orderId: _this.queryForm.orderId,
        // orderIds: _this.queryForm.orderId,
        refNumbers: _this.queryForm.refNumbers,
        customerIds: _this.queryForm.customerIds,
        productIds: _this.queryForm.productIds,
        status: _this.queryForm.status,
        startDate: _this.queryForm.startDate,
        endDate: _this.queryForm.endDate,
        currentPage: _this.currentPage,
        pageSize: _this.pageSize,
        warehouseIds: wlist
      };
      this.$request1
        .post(
          '/separate-quote-order',
          formdata,
          {
            // params: formdata,
            timeout: 10000,
            withCredentials: true,
            // headers: {
            //   "content-type": "application/x-www-form-urlencoded"
            // }
          }
        )
        .then(function(response) {
          _this.tableData = response.data.data;
          _this.total = response.data.total;
          //console.log('_this.tableData' +JSON.stringify( _this.tableData))
          _this.tableData.forEach((v, i) => {
            v.date = _this.formatDate(
              new Date(v.createDate),
              "yyyy-MM-dd HH:mm:ss"
            );
            if (!v.driver) {
              v.driver = {};
            }
            if (!v.vehicle) {
              v.vehicle = {};
            }
          });
        })
        .catch(function(error) {
          //console.log(error);
        });
    },
    editPrice() {
      this.isEditPrice = true;
      this.$nextTick(function() {
        this.$el.focus();
      });
    },
    savePrice(data) {
      let flag = false;
      data.forEach((item, index) => {
        item.expr = item.chargeType + ":" + item.price;
        if (!item.from || !item.unitWeight || !item.price || !item.costPrice) {
          flag = true;
        }
      });
      if (flag) {
        this.$notify.warning({
          title: "提示",
          message: "数据不能为空"
        });
      } else {
        this.isEditPrice = false;
      }
    },
    quote(row) {
      //   this.dialogFormVisible = true;
      //   this.cartonQty = row.totalCarton;
      //   this.orderId = row.id;
      let _this = this;
      this.priceForm.editId = "";
      this.$request1
        .get(
          '/price/currentPrice',
          {
            params: {
              orgOwner: row.orgOwner,
              channelId: row.productId
            },
            timeout: 10000,
            withCredentials: true,
            headers: {
              "content-type": "application/x-www-form-urlencoded"
            }
          }
        )
        .then(function(response) {
          _this.priceDefinition = response.data.data;
          //_this.dialogDefinitionVisible = true;
          //设置属性
          _this.priceDefinition.mainCharge.logisticPrice.areas = [];
          _this.priceDefinition.mainCharge.logisticPrice.prices = {};
          _this.priceDefinition.mainCharge.cal = "SHIPMENT";
          _this.priceDefinition.mainCharge.formula = null;
          _this.priceDefinition.mainCharge.logisticPrice.areas.push({
            areaCode: row.country,
            regions: [row.country]
          });
          _this.priceDefinition.mainCharge.logisticPrice.selectedAreaCode =
            row.country;
          _this.priceForm.orderId = row.id;
          //console.log("_this.priceDefinition>>>>="+JSON.stringify(_this.priceDefinition));
          _this.dialogFormVisible = true;
        })
        .catch(function(error) {
          //console.log(error);
        });
    },
    quoteEdit(row) {
      //   this.dialogFormVisible = true;
      //   this.cartonQty = row.totalCarton;
      //   this.orderId = row.id;
      let _this = this;
      this.$request1
        .get(
          '/price/currentOrderPrice',
          {
            params: {
              orderId: row.id
            },
            timeout: 10000,
            withCredentials: true,
            headers: {
              "content-type": "application/x-www-form-urlencoded"
            }
          }
        )
        .then(function(response) {
          if (!response.data.success) {
            this.$notify.error({
              title: "提示",
              message: response.data.message
            });
            return;
          }
          _this.priceDefinition = response.data.data;
          //初始化编辑
          _this.priceDefinition.mainCharge.cal = "SHIPMENT";
          _this.priceDefinition.mainCharge.formula = null;
          _this.priceDefinition.mainCharge.logisticPrice.areas = [];
          _this.priceDefinition.mainCharge.logisticPrice.areas.push({
            areaCode: row.country,
            regions: [row.country]
          });
          for (var k in _this.priceDefinition.mainCharge.logisticPrice.prices) {
            if (k != row.country) {
              delete _this.priceDefinition.mainCharge.logisticPrice.prices[k];
            }
          }
          _this.priceDefinition.mainCharge.logisticPrice.selectedAreaCode =
            row.country;
          _this.priceForm.orderId = row.id;
          _this.priceForm.editId = _this.priceDefinition.id;
          //console.log("_this.priceDefinition>>>>="+JSON.stringify(_this.priceDefinition));
          _this.dialogFormVisible = true;
        })
        .catch(function(error) {
          //console.log(error);
        });
    },
    createPriceAndContinue() {
      let _this = this;
      this.$refs["newPriceForm"].validate(valid => {
        if (valid) {
          _this._createPrice();
        } else {
        }
      });
    },
    // 添加重量段及价格
    createPrice() {
      let _this = this;
      this.$refs["newPriceForm"].validate(valid => {
        if (valid) {
          _this._createPrice();
          _this.dialogFromVisible = false;
        } else {
        }
      });
    },
    _createPrice() {
      let prices = this.priceDefinition.mainCharge.logisticPrice.prices;
      let selectedCode = this.priceDefinition.mainCharge.logisticPrice
        .selectedAreaCode;
      this.newPrice.expr = this.newPrice.chargeType + ":" + this.newPrice.price;
      if (prices[selectedCode] !== null && prices[selectedCode] !== undefined) {
        prices[selectedCode].push(this.newPrice);
      } else {
        prices[selectedCode] = [this.newPrice];
      }
      this.clearNewPrice();
    },
    clearNewPrice() {
      this.newPrice = {
        areaCode: "",
        from: "",
        to: "",
        unitWeight: "",
        price: "",
        costPrice: "",
        chargeType: "CONSTANT",
        expr: ""
      };
    },
    // 重量段及价格---删除一行
    deletePrice(index) {
      let selectedCode = this.priceDefinition.mainCharge.logisticPrice
        .selectedAreaCode;
      let prices = this.priceDefinition.mainCharge.logisticPrice.prices;
      prices[selectedCode].splice(index, 1);
      this.$forceUpdate();
    },
    addMainCharge() {
      this.dialogFromVisible = true;
    },
    submitDone() {
      let _this = this;
      var priceList = this.priceDefinition.mainCharge.logisticPrice.prices[
        this.priceDefinition.mainCharge.logisticPrice.selectedAreaCode
      ];
      if (priceList == null || priceList.length == 0) {
        this.$message.error("请添加费用");
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.$request1
        .post(
          '/separate-quote-order/quote',
          {
            priceDefinitions: [_this.priceDefinition],
            orderId: _this.priceForm.orderId
          },
          {
            timeout: 30000,
            withCredentials: true,
            headers: {
              "content-type": "application/json"
            }
          }
        )
        .then(function(response) {
          loading.close();
          if (response.data.success) {
            _this.$message({
              message: "提交成功",
              type: "success"
            });
            _this.dialogFormVisible = false;
            for (let index = 0; index < _this.tableData.length; index++) {
              if (_this.tableData[index].id == _this.orderId) {
                _this.tableData.splice(index, 1);
                break;
              }
            }
            _this.tableData;
            _this.searchTask();
          } else {
            _this.$message.error("提交失败：" + response.data.message);
          }
        })
        .catch(function(error) {
          loading.close();
        });
    },
    formatDate(date, fmt) {
      if (!date) {
        return "";
      }
      var o = {
        "M+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "h+": date.getHours() % 12 == 0 ? 12 : date.getHours() % 12, //小时
        "H+": date.getHours(), //小时
        "m+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        S: date.getMilliseconds() //毫秒
      };
      var week = {
        "0": "/u65e5",
        "1": "/u4e00",
        "2": "/u4e8c",
        "3": "/u4e09",
        "4": "/u56db",
        "5": "/u4e94",
        "6": "/u516d"
      };
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }
      if (/(E+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (RegExp.$1.length > 1
            ? RegExp.$1.length > 2
              ? "/u661f/u671f"
              : "/u5468"
            : "") + week[date.getDay() + ""]
        );
      }
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
        }
      }
      return fmt;
    }
  }
};
//function formatDate(date,fmt){if(!date){return""}var o={"M+":date.getMonth()+1,"d+":date.getDate(),"h+":date.getHours()%12==0?12:date.getHours()%12,"H+":date.getHours(),"m+":date.getMinutes(),"s+":date.getSeconds(),"q+":Math.floor((date.getMonth()+3)/3),"S":date.getMilliseconds()};var week={"0":"/u65e5","1":"/u4e00","2":"/u4e8c","3":"/u4e09","4":"/u56db","5":"/u4e94","6":"/u516d"};if(/(y+)/.test(fmt)){fmt=fmt.replace(RegExp.$1,(date.getFullYear()+"").substr(4-RegExp.$1.length))}if(/(E+)/.test(fmt)){fmt=fmt.replace(RegExp.$1,((RegExp.$1.length>1)?(RegExp.$1.length>2?"/u661f/u671f":"/u5468"):"")+week[date.getDay()+""])}for(var k in o){if(new RegExp("("+k+")").test(fmt)){fmt=fmt.replace(RegExp.$1,(RegExp.$1.length==1)?(o[k]):(("00"+o[k]).substr((""+o[k]).length)))}}return fmt};
</script>
<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/views/orderOperation/separatequote.vue